/* Before and after rail: dots that follow the swipe, plus arrows on desktop */
(function () {
  'use strict';
  var rail = document.querySelector('.ew-results-grid');
  if (!rail) return;
  var cards = rail.querySelectorAll('.ew-ba');
  if (cards.length < 2) return;
  var bar = document.createElement('div');
  bar.className = 'ew-results-dots';
  cards.forEach(function (card, i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', 'Show customer ' + (i + 1));
    b.addEventListener('click', function () { rail.scrollTo({ left: card.offsetLeft - rail.offsetLeft, behavior: 'smooth' }); });
    bar.appendChild(b);
  });
  var arrows = document.createElement('div');
  arrows.className = 'ew-results-arrows';
  [['prev', 'Previous customer', -1], ['next', 'Next customer', 1]].forEach(function (a) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'ew-arrow ew-arrow--' + a[0]; b.setAttribute('aria-label', a[1]);
    b.addEventListener('click', function () { rail.scrollBy({ left: a[2] * (cards[0].offsetWidth + 20), behavior: 'smooth' }); });
    arrows.appendChild(b);
  });
  var wrap = document.createElement('div');
  wrap.className = 'ew-results-nav';
  wrap.appendChild(bar); wrap.appendChild(arrows);
  rail.parentNode.insertBefore(wrap, rail.nextSibling);
  var update = function () {
    var max = rail.scrollWidth - rail.clientWidth;
    wrap.hidden = max < 4;
    var i = max < 4 ? 0 : Math.round((rail.scrollLeft / max) * (cards.length - 1));
    bar.querySelectorAll('button').forEach(function (b, j) { b.setAttribute('aria-current', String(j === i)); });
    arrows.firstChild.disabled = rail.scrollLeft < 4;
    arrows.lastChild.disabled = rail.scrollLeft > max - 4;
  };
  rail.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
